export default __webpack_public_path__ + "static/media/client-10.129a8d2e.webp";